export default {
  TITLE: 'Identificação',
  NOME: 'Nome',
  STATUS: 'Status',
  EMAIL: 'E-mail',
  RESPONSAVEL: 'Responsável',
  CENTRO_CUSTO: 'Centro Custo',
};
